<template>
  <v-container grid-list-xl>
    <v-layout wrap justify-space-between v-if="finished">
      <v-flex xs12 md12>
        <h1>Event Profile Updated</h1>
        <div mb-4 xs-4 v-if="true || attendee.can_buy_activation">
          <h2 my-1 style="background: yellow">
            <v-icon>fas fa-exclamation-triangle</v-icon>&nbsp; WARNING <br />You
            are NOT done yet <br />You still need an event ticket <br />
            아직 행사 신청이 완료되지 않았습니다. <br />
            다음 화면에서 원하시는 패스를 <br />등록하시기 바랍니다.
          </h2>
        </div>
        <v-btn :to="`/events/${this.$route.params.event_id}`"
          >행사 신청/확인 / Event Menu</v-btn
        >
      </v-flex>
    </v-layout>

    <v-layout wrap justify-space-between v-if="!finished && !ready">
      <h1>Loading...</h1>
    </v-layout>
    <v-layout wrap justify-space-between v-if="!finished && ready">
      <v-flex xs12 md12>
        <h1>My {{ event.title }} Profile</h1>
        Add Personal Event Profile Info for this event
        <br />해당 이벤트을 등록하기 위해 필요한 참가자 정보 등록

        <v-form ref="form">
          <v-text-field
            v-model="nickname"
            label="닉네임 / By what name would should we address you?"
          ></v-text-field>
          스윙씬에서 사용하고 있는 명칭을 입력해주세요.
          <br />This will be used when announcing your name

          <br />
          <br />
          <v-text-field
            v-model="other_city"
            :rules="[rules.required, rules.reasonable_length]"
            label="도시/City"
          ></v-text-field>

          <div v-if="false">
            <br />
            <br />
            <v-select
              v-model="well_known_affiliation"
              :items="well_known_affiliations"
              label="동호회/소속/ Club/City/Country"
            ></v-select>
            <v-text-field
              v-if="well_known_affiliation == '기타 / Other'"
              v-model="affiliation"
              :rules="[rules.required, rules.reasonable_length]"
              label="기타 수동 입력 /  Input your Club/City/Country"
            ></v-text-field>
            행사 진행시 좀 더 개인화된 서비스를 제공하기 위해서 입력 받습니다.
            <br />Please let us know what club/city/country you come from. If
            "other", please enter on the second line. 행사 진행시 좀 더 개인화된
            서비스를 제공하기 위해서 입력 받습니다. <br />Used to help place you
            in the same room with your friends
          </div>

          <v-radio-group
            v-model="role"
            :mandatory="true"
            :rules="[rules.required]"
          >
            <div slot="label">
              역할 Your <strong>main dancing role</strong><br />&nbsp; (even if
              you can do both)
            </div>
            <v-radio label="리더 Leader" value="L"></v-radio>
            <v-radio label="팔로워 Follower" value="F"></v-radio>
          </v-radio-group>

          <v-radio-group
            v-model="payment_region"
            :mandatory="true"
            :rules="[rules.required]"
          >
            <div slot="label">
              한국 사람 "한국" 선택해요 / Will you be paying from outside Korea?
            </div>
            <v-radio label="한국 계좌 이체" value="KR"></v-radio>
            <v-radio label="Outside of Korea" value="ROW"></v-radio>
          </v-radio-group>

          <br />
          <v-text-field
            v-model="partner_name"
            label="파티 파트너 / Party Partner's Name"
          ></v-text-field>
          파트너 이름
          <br />Let us know the name of your dance partner if you are attending
          our event together.

          <br />
          <v-text-field
            v-model="combined_strictly_partner_name"
            label="스트릭틀리 파트너 / Strictly Partner"
          ></v-text-field>
          스트릭틀리 대회 파트너 이름
          <br />Your Partner's Name if competing in Strictly

          <br />
          <br />
          <v-text-field
            v-model="sns_contact"
            label="SNS 연락방법 / Facebook / WeChat / WhatsApp"
          ></v-text-field>
          전화랑 이메일 연락 못 하는 경우 추가 방법
          <br />How can we get in touch with you to resolve issues? Recommend a
          chat program or social networking service
        </v-form>
      </v-flex>
      <v-btn color="primary" @click="confirm"
        >이벤트 프로필 등록 Update Event Profile</v-btn
      >
    </v-layout>
  </v-container>
</template>

<script>
import {mapState} from 'vuex';
export default {
  props: ['auth'],
  data: () => ({
    ready: false,
    nickname: '',
    affiliation: '',
    level_1: '',
    nickname: '',
    other_city: '',
    payment_region: '',
    partner_name: '',
    sns_contact: '',
    combined_strictly_partner_name: '',
    amateur_strictly_partner_name: '',
    open_strictly_partner_name: '',
    role: '',
    rules: {
      required: value => !!value || 'Required.',
      reasonable_length: value =>
        (!!value && (value.length >= 2 && value.length < 32)) ||
        'At least 2 characters',
    },
    finished: false,
    well_known_affiliation: '',
    well_known_affiliations: [],
  }),
  beforeMount: async function() {
    await this.$store.dispatch('loadEvents');
    await this.$store.dispatch('loadAttendees', {
      event_id: this.$route.params.event_id,
    });
    if (this.$route.params.event_id == 23) {
      this.well_known_affiliations = [
        '기타 / Other',
        'Adelaide',
        'Aichi',
        'Bangkok',
        'Beijing',
        'Brisbane',
        'Den Haag',
        'Denver',
        'Guangzhou',
        'Hangzhou',
        'Hong Kong',
        'HSINCHU',
        'Hsinchu',
        'Kawasaki',
        'Kirkland',
        'Knoxville',
        'Korea (USA)',
        'Kuala Lumpur',
        'LA',
        'Lafayette',
        'London',
        'Melbourne',
        'Moscow',
        'Nagoya',
        'Perth',
        'San Francisco',
        'Sendai',
        'Shanghai',
        'Singapore',
        'Swiss',
        'Taipei',
        'Taoyuan',
        'Tokyo',
        'Wuhan',
        'Xiamen',
        'Zurich',
        '공주',
        '광명',
        '광주',
        '대구',
        '부산',
        '부천',
        '서울',
        '성남',
        '세종',
        '수원',
        '안양',
        '오산',
        '인천',
        '제주',
        '천안',
      ];
    }
  },
  watch: {
    $route(to, from) {
      console.log('RS', 'watch route', to, from); // react to route changes...
    },
    attendees(to, from) {
      console.log('RS', 'watch attendees', to, from); // react to route changes...
      this.show_attendee(to);
    },
  },
  computed: {
    ...mapState(['myprofile', 'events', 'attendees']),
    attendee() {
      return this.attendees?.find(a => {
        return a.event_id == this.$route.params.event_id;
      });
    },
    event: function() {
      return this.events?.find(x => {
        return x.id == this.$route.params.event_id;
      });
    },
    upsert_data: function() {
      return {
        attendee: {
          event_id: this.$route.params.event_id,
          nickname: this.$data.nickname,
          affiliation: this.$data.affiliation,
          level_1: this.$data.level_1,
        },
        attendee_event_meta: [
          {key: 'role', value: this.$data.role},
          {key: 'payment_region', value: this.$data.payment_region},
          {key: 'partner_name', value: this.$data.partner_name},
          {key: 'sns_contact', value: this.$data.sns_contact},
          {
            key: 'well_known_affiliation',
            value: this.$data.well_known_affiliation,
          },
          {key: 'other_city', value: this.$data.other_city},
          {
            key: 'combined_strictly_partner_name',
            value: this.$data.combined_strictly_partner_name,
          },
          {
            key: 'amateur_strictly_partner_name',
            value: this.$data.amateur_strictly_partner_name,
          },
          {
            key: 'open_strictly_partner_name',
            value: this.$data.open_strictly_partner_name,
          },
        ],
      };
    },
  },
  methods: {
    extract_meta(attendee, key) {
      let found = attendee?.attendee_event_meta?.find(aem => {
        return aem.key == key;
      });
      return found?.value;
    },
    show_attendee(attendees) {
      let attendee = attendees?.find(pe => {
        return pe.event_id == this.$route.params.event_id;
      });
      this.$data.nickname = attendee?.nickname;
      this.$data.affiliation = attendee?.affiliation;
      this.$data.level_1 = attendee?.level_1;

      this.$data.role = this.extract_meta(attendee, 'role');
      this.$data.payment_region = this.extract_meta(attendee, 'payment_region');
      this.$data.partner_name = this.extract_meta(attendee, 'partner_name');
      this.$data.sns_contact = this.extract_meta(attendee, 'sns_contact');
      this.$data.other_city = this.extract_meta(attendee, 'other_city');
      this.$data.well_known_affiliation = this.extract_meta(
        attendee,
        'well_known_affiliation',
      );
      /*
      this.$data.amateur_strictly_partner_name = this.extract_meta(
        attendee,
        'amateur_strictly_partner_name',
      );
      this.$data.open_strictly_partner_name = this.extract_meta(
        attendee,
        'open_strictly_partner_name',
      );
*/

      this.$data.combined_strictly_partner_name = this.extract_meta(
        attendee,
        'combined_strictly_partner_name',
      );

      /*
      let role_aem = attendee?.attendee_event_meta?.find(aem => {
        return aem.key == 'role';
      });
      this.$data.role = role_aem?.value;

      let payment_region_aem = attendee?.attendee_event_meta?.find(aem => {
        return aem.key == 'payment_region';
      });
      this.$data.payment_region = payment_region_aem?.value;

      let partner_name_aem = attendee?.attendee_event_meta?.find(aem => {
        return aem.key == 'partner_name';
      });
      this.$data.partner_name = partner_name_aem?.value;

      let sns_contact_aem = attendee?.attendee_event_meta?.find(aem => {
        return aem.key == 'sns_contact';
      });
      this.$data.sns_contact = sns_contact_aem?.value;

      let other_city_aem = attendee?.attendee_event_meta?.find(aem => {
        return aem.key == 'other_city';
      });
      this.$data.other_city = other_city_aem?.value;

      let well_known_affiliation_aem = attendee?.attendee_event_meta?.find(
        aem => {
          return aem.key == 'well_known_affiliation';
        },
      );
      this.$data.well_known_affiliation = well_known_affiliation_aem?.value;
*/
      this.$data.ready = true;
    },
    confirm: async function({router}) {
      if (this.$refs.form.validate()) {
        var res = await this.$store.dispatch(
          'updateAttendee',
          this.upsert_data,
        );
        console.log('check result', res);
        let cancelHandle = this.$scrollTo('#appbody'); // scroll to top of page
        this.finished = true;
      }
    },
  },
};
</script>
